import * as Types from '../index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetFileTemplatesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetFileTemplatesQuery = { __typename?: 'Query', FileTemplates: Array<{ __typename?: 'FileTemplateEntity', id: string, name?: string | null, fileName?: string | null }> };

export type DownloadFileTemplateContentQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type DownloadFileTemplateContentQuery = { __typename?: 'Query', DownloadFileTemplateContent: string };

export type UpdateFileTemplateMutationVariables = Types.Exact<{
  updateFileTemplateInput: Types.UpdateFileTemplateInput;
}>;


export type UpdateFileTemplateMutation = { __typename?: 'Mutation', UpdateFileTemplate: { __typename?: 'FileTemplateEntity', id: string, name?: string | null, fileName?: string | null } };

export type DeleteFileTemplateMutationVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type DeleteFileTemplateMutation = { __typename?: 'Mutation', DeleteFileTemplate: { __typename?: 'FileTemplateEntity', id: string } };


export const GetFileTemplatesDocument = gql`
    query GetFileTemplates {
  FileTemplates {
    id
    name
    fileName
  }
}
    `;

/**
 * __useGetFileTemplatesQuery__
 *
 * To run a query within a React component, call `useGetFileTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFileTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetFileTemplatesQuery, GetFileTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFileTemplatesQuery, GetFileTemplatesQueryVariables>(GetFileTemplatesDocument, options);
      }
export function useGetFileTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFileTemplatesQuery, GetFileTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFileTemplatesQuery, GetFileTemplatesQueryVariables>(GetFileTemplatesDocument, options);
        }
export type GetFileTemplatesQueryHookResult = ReturnType<typeof useGetFileTemplatesQuery>;
export type GetFileTemplatesLazyQueryHookResult = ReturnType<typeof useGetFileTemplatesLazyQuery>;
export type GetFileTemplatesQueryResult = Apollo.QueryResult<GetFileTemplatesQuery, GetFileTemplatesQueryVariables>;
export const DownloadFileTemplateContentDocument = gql`
    query DownloadFileTemplateContent($id: String!) {
  DownloadFileTemplateContent(id: $id)
}
    `;

/**
 * __useDownloadFileTemplateContentQuery__
 *
 * To run a query within a React component, call `useDownloadFileTemplateContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadFileTemplateContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadFileTemplateContentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDownloadFileTemplateContentQuery(baseOptions: Apollo.QueryHookOptions<DownloadFileTemplateContentQuery, DownloadFileTemplateContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadFileTemplateContentQuery, DownloadFileTemplateContentQueryVariables>(DownloadFileTemplateContentDocument, options);
      }
export function useDownloadFileTemplateContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadFileTemplateContentQuery, DownloadFileTemplateContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadFileTemplateContentQuery, DownloadFileTemplateContentQueryVariables>(DownloadFileTemplateContentDocument, options);
        }
export type DownloadFileTemplateContentQueryHookResult = ReturnType<typeof useDownloadFileTemplateContentQuery>;
export type DownloadFileTemplateContentLazyQueryHookResult = ReturnType<typeof useDownloadFileTemplateContentLazyQuery>;
export type DownloadFileTemplateContentQueryResult = Apollo.QueryResult<DownloadFileTemplateContentQuery, DownloadFileTemplateContentQueryVariables>;
export const UpdateFileTemplateDocument = gql`
    mutation UpdateFileTemplate($updateFileTemplateInput: UpdateFileTemplateInput!) {
  UpdateFileTemplate(updateFileTemplateInput: $updateFileTemplateInput) {
    id
    name
    fileName
  }
}
    `;
export type UpdateFileTemplateMutationFn = Apollo.MutationFunction<UpdateFileTemplateMutation, UpdateFileTemplateMutationVariables>;

/**
 * __useUpdateFileTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateFileTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFileTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFileTemplateMutation, { data, loading, error }] = useUpdateFileTemplateMutation({
 *   variables: {
 *      updateFileTemplateInput: // value for 'updateFileTemplateInput'
 *   },
 * });
 */
export function useUpdateFileTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFileTemplateMutation, UpdateFileTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFileTemplateMutation, UpdateFileTemplateMutationVariables>(UpdateFileTemplateDocument, options);
      }
export type UpdateFileTemplateMutationHookResult = ReturnType<typeof useUpdateFileTemplateMutation>;
export type UpdateFileTemplateMutationResult = Apollo.MutationResult<UpdateFileTemplateMutation>;
export type UpdateFileTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateFileTemplateMutation, UpdateFileTemplateMutationVariables>;
export const DeleteFileTemplateDocument = gql`
    mutation DeleteFileTemplate($id: String!) {
  DeleteFileTemplate(id: $id) {
    id
  }
}
    `;
export type DeleteFileTemplateMutationFn = Apollo.MutationFunction<DeleteFileTemplateMutation, DeleteFileTemplateMutationVariables>;

/**
 * __useDeleteFileTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteFileTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFileTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFileTemplateMutation, { data, loading, error }] = useDeleteFileTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFileTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFileTemplateMutation, DeleteFileTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFileTemplateMutation, DeleteFileTemplateMutationVariables>(DeleteFileTemplateDocument, options);
      }
export type DeleteFileTemplateMutationHookResult = ReturnType<typeof useDeleteFileTemplateMutation>;
export type DeleteFileTemplateMutationResult = Apollo.MutationResult<DeleteFileTemplateMutation>;
export type DeleteFileTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteFileTemplateMutation, DeleteFileTemplateMutationVariables>;
export const namedOperations = {
  Query: {
    GetFileTemplates: 'GetFileTemplates',
    DownloadFileTemplateContent: 'DownloadFileTemplateContent'
  },
  Mutation: {
    UpdateFileTemplate: 'UpdateFileTemplate',
    DeleteFileTemplate: 'DeleteFileTemplate'
  }
}